export default function reduce(state, action) {
  switch (action.type) {
    case "ADD":
      return { ...state, Data: [...state.Data, action.payload] };
    case "UPDATE":
      return {
        ...state,
        Data: state.Data.map((item) => {
          if (item.id === action.payload.id) {
            return { ...item, desc: action.payload.desc };
          }
          return item;
        })
      };
    case "FILTER":
      return {
        ...state,
        filterBy: action.payload
      };
    case "DELETE":
      return {
        ...state,
        Data: state.Data.filter((item) => {
          return item.id !== action.payload.id;
        })
      };
    default:
      break;
  }
}
